export default "__VITE_ASSET__030fa2d4__"